export default "__VITE_ASSET__D$yvZiz7__"